import BaseSelectroPresenter from './BaseSelectroPresenter';
import {
  type SelectroTemplates,
  type SelectroText,
} from '@aha-app/selectro-v2';
import terminology from 'javascripts/terminology';

// to use, import the singleton  FeaturesSelectroPresenter from 'components/SelectroV2/SelectroPresenters';
class FeaturesSelectroPresenterDefinition extends BaseSelectroPresenter {
  baseTemplates(): SelectroTemplates {
    return {};
  }

  baseText(): SelectroText {
    return {
      searchPlaceholder: `Search by name or ${terminology('project')}`,
    };
  }
}

export default FeaturesSelectroPresenterDefinition;
